export default {
      id: "uspCard-switchBetweenFunds-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#uspCard-switchBetweenFunds",
      toString: function () {
        return this.url;
      }
    }